import { combineReducers } from 'redux';
import diagram from './diagram';
import main from './main';
import canvas from './canvas';
import auth from "./auth";
import notify from './notify';

const rootReducer = combineReducers({
    diagram,
    main,
    canvas,
    auth,
    notify,
});

export default rootReducer;
